import { render, staticRenderFns } from "./StocksMapPage.vue?vue&type=template&id=acac37b6&"
import script from "./StocksMapPage.vue?vue&type=script&lang=ts&"
export * from "./StocksMapPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports